import { type JSX } from "react"
import Home from "../components/home/home"
import Biography from '../components/biography/biography'
import {MediaItem} from '../components/media/mediaItem'
import {Portfolio} from '../components/portfolio/portfolio'
import { MediaList } from '../components/media/mediaList'
import { Contact } from '../components/contact/contact'
import { Page } from '../components/commons/page/page'
import { PageNotFound } from "../components/page-not-found/page-not-found"
import { Reviews } from "../components/reviews/reviews"

export interface AppRoute {
  path: string
  element: JSX.Element
  extraProps?: Record<string, any> // pour props dynamiques comme setTranslations
}

export const ROUTES: AppRoute[] = [
  { path: '/:lang', element: <Home /> },
  { path: '/:lang/about', element: <Biography /> },
  { path: '/:lang/media', element: <MediaItem /> },
  { path: '/:lang/portfolio', element: <Portfolio /> },
  {
    path: '/:lang/portfolio/category/:slug',
    element: <MediaList />,
    extraProps: {} // sera rempli depuis App.tsx
  },
  { path: '/:lang/reviews', element: <Reviews />},
  { path: '/:lang/contact', element: <Contact /> },
  { path: '/:lang/juine-canvases', element: <Page/>, extraProps: { slugPrefix: 'juine-canvases-' } },
  { path: '/:lang/legal-notice', element: <Page />, extraProps: { slugPrefix: 'legal-notice-' } },
  { path: '/:lang/privacy-policy', element: <Page />, extraProps: { slugPrefix: 'privacy-policy-' } },
  { path: '/:lang/*', element: <PageNotFound />},

]
